export default __webpack_public_path__ + "static/media/Logo-TBRC.a163125d.png";